"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSearchInputStyles = void 0;
var core_1 = require("@material-ui/core");
var _colors_1 = require("../../../style/commons/_colors");
exports.useSearchInputStyles = (0, core_1.makeStyles)(function () { return ({
    inputRoot: {
        flexWrap: 'nowrap',
        padding: '0px 16px 0px 0px !important',
        '& > fieldset': {
            border: 'none',
        },
    },
    input: {
        padding: '0 12px !important',
        outline: 'none',
    },
    options: {
        padding: 0,
    },
    option: {
        height: 40,
        paddingTop: 0,
        paddingBottom: 0,
        '&:hover': {
            backgroundColor: _colors_1.lightLightBlue,
        },
        '&[aria-selected="true"]': {
            backgroundColor: 'transparent',
        },
        '&[data-focus="true"]': {
            backgroundColor: _colors_1.lightLightBlue,
        },
    },
    paper: {
        margin: '4px 0 0 0',
        borderRadius: '4px',
        boxShadow: '0 8px 16px 0 rgba(0, 0, 0, 0.08)',
    },
    clear: {
        color: _colors_1.brandPrimaryMaxDark,
    },
}); });
